"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigateHeaderRemove = exports.navigateHeader = exports.copyToClipboard = exports.goTo = exports.getStoreInfo = exports.syncPathname = exports.getCurrentPathname = exports.getSessionToken = exports.navigateBack = exports.navigateExit = exports.iAmReady = exports.connect = void 0;
var actions_1 = require("../actions/actions");
var utils_1 = require("../core/utils");
var connect = function (nexo, ttl) {
    if (ttl === void 0) { ttl = 3000; }
    return new Promise(function (resolve, reject) {
        var timeOut = setTimeout(function () {
            reject(new Error("Timeout"));
        }, ttl);
        nexo.onReady(function () {
            resolve();
            clearTimeout(timeOut);
        });
    });
};
exports.connect = connect;
var iAmReady = function (nexo) {
    nexo.dispatch((0, utils_1.message)(actions_1.ACTION_READY));
};
exports.iAmReady = iAmReady;
var navigateExit = function (nexo) {
    nexo.dispatch((0, utils_1.message)(actions_1.ACTION_NAVIGATE_EXIT));
};
exports.navigateExit = navigateExit;
var navigateBack = function (nexo) {
    nexo.dispatch((0, utils_1.message)(actions_1.ACTION_NAVIGATE_BACK));
};
exports.navigateBack = navigateBack;
var getSessionToken = function (nexo) { return __awaiter(void 0, void 0, void 0, function () {
    var token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, utils_1.asyncAction)(nexo, actions_1.ACTION_AUTH_SESSION_TOKEN)];
            case 1:
                token = (_a.sent()).token;
                return [2 /*return*/, token];
        }
    });
}); };
exports.getSessionToken = getSessionToken;
var getCurrentPathname = function (nexo) { return __awaiter(void 0, void 0, void 0, function () {
    var pathname;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, utils_1.asyncAction)(nexo, actions_1.ACTION_NAVIGATE_PATHNAME)];
            case 1:
                pathname = (_a.sent()).pathname;
                return [2 /*return*/, pathname];
        }
    });
}); };
exports.getCurrentPathname = getCurrentPathname;
var syncPathname = function (nexo, pathname) {
    nexo.dispatch((0, utils_1.message)(actions_1.ACTION_NAVIGATE_SYNC, { pathname: pathname }));
};
exports.syncPathname = syncPathname;
var getStoreInfo = function (nexo) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, utils_1.asyncAction)(nexo, actions_1.ACTION_STORE_INFO)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getStoreInfo = getStoreInfo;
var goTo = function (nexo, pathname) {
    nexo.dispatch((0, utils_1.message)(actions_1.ACTION_NAVIGATE_GOTO, { pathname: pathname }));
};
exports.goTo = goTo;
var copyToClipboard = function (nexo, text) { return __awaiter(void 0, void 0, void 0, function () {
    var success;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, utils_1.asyncAction)(nexo, actions_1.ACTION_UTILS_COPY_TO_CLIPBOARD, { text: text })];
            case 1:
                success = (_a.sent()).success;
                return [2 /*return*/, success];
        }
    });
}); };
exports.copyToClipboard = copyToClipboard;
var navigateHeader = function (nexo, config) {
    nexo.dispatch({
        type: actions_1.ACTION_NAVIGATE_HEADER,
        payload: config,
    });
};
exports.navigateHeader = navigateHeader;
var navigateHeaderRemove = function (nexo) {
    nexo.dispatch({
        type: actions_1.ACTION_NAVIGATE_HEADER,
        payload: { remove: true },
    });
};
exports.navigateHeaderRemove = navigateHeaderRemove;
